import React, { Component, Fragment } from "react";
import "./InlineModal.scss";
import parse from "html-react-parser";

// import "react-table-v6/react-table.css";
import FieldDisabled from "../FieldDisabled";
import Modal from "react-modal";
import { MdClose } from "react-icons/md";
import { FieldArray } from "react-final-form-arrays";
import { Field } from "react-final-form";
import PopupMenu from "../PopupMenu";
import FEINValidation from "../FEINValidation";

import DOMPurify from "dompurify";

import { validator } from "../validation";
import FieldResolver from "../FieldResolver";
import FieldError from "../FieldError";
import Condition from "../Conditionals/Condition";
import ClearBtn from "../UI/ClearBtn";
import fieldParser from "../FieldParser";

import Label from "../UI/Label";
import Tooltip from "../UI/FormTooltip";
import RequiredAsterisk from "../UI/RequiredAsterisk";
import Button from "../UI/Button";
import { PaginationComponent } from "../ReactTable/ReactTablePagination";
import { LinkageEditableCell, DeleteLinkageModal } from "./Linkages";
import { sortListBy } from "./utils/utils";

const conditionalStyles = {
  // background: "#f7f7f7",
  // border: "1px solid #C3C5C9",
  // padding: "0px 16px 28px 21px",
  // width: "100%",
  // marginTop: "1rem",
};

const warningStyles = {
  backgroundColor: "#e9e9e9",
  border: "1px solid #d2d3d6",
  padding: "28px 16px 28px 21px",
  width: "100%",
  marginTop: "1rem",
};

const checkboxStyleObj = {
  WebkitColumnCount: "2" /* Chrome, Safari, Opera */,
  MozColumnCount: "2" /* Firefox */,
  columnCount: "2",
};

const styles = {
  modalStyles: {
    position: "relative",
    top: "0",
    width: "650px",
    height: "auto",
    marginRight: "auto",
    marginReft: "auto",
    border: "1px solid rgb(204, 204, 204)",
    background: "rgb(255, 255, 255)",
    overflow: "auto",
    borderRradius: "4px",
    outline: "none",
  },
  closeButton: {
    position: "absolute",
    right: "20px",
    top: "20px",
    background: "none",
    border: "none",
    padding: 0,
  },
  closeButtonIcon: {
    height: "35px",
    width: "35px",
  },
  saveButton: {
    margin: "50px 0 50px 0",
    display: "flex",
    float: "right",
    width: "134px",
  },
};
/*
-This component takes in fields from the UI Schema and adds value to the machine name provided from the Schema using a modal.
    -All the fields in the modal is one FieldArray with sub Fields
-It holds values at a page level and displays it as requirements (see Render method)
-You can also provide a "Master Array" which can hold all the other arrays in one
-If you need to display the data in a different UI, then create a new , listType flag (see modal schema or render method)
*/

export default class InlineModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // Base
      modalIsOpen: false,
      componentValuesArr: [],
      remainingValuesArr: [], // only exists if a Master Arr exists
      masterValuesArr: [],
      editMode: false,
      // Linkages
      linkageEditMode: false, // for updating linkages and rerendering
      linkagesValues: {}, // for storing display values for inline modal table
      // Linkages editing
      linkageEditingObject: {
        idValue: "",
        toLinkageIdFieldName: "",
        fieldsToModify: "",
      },
      linkageDeletionModalIsOpen: false,
      // Linkages removing
      linkageDeletionObject: {
        linkageRowDeletionData: undefined, // filtered rows for Deletion for UI purposes
        linkageModifiedData: undefined, // new modified data to replace fieldArray
        linkageDeletionId: "",
        removeRow: false,
        linkagesSchemaProps: {
          linkages: {},
        },
      },
      // Pagination
      rowCount: 0,
      currentIndex: null,
      row: null,
      hide: null,
      pageIndex: 0,
      pageSize: 10,
      pageCount: 0,
    };
  }
  componentDidMount() {
    this.updateFormValuesAndLocalStateValues();
    if (this.props.section.hasOwnProperty("master_fieldArray")) {
      this.setState({ type: "inline" });
    } else {
      this.setState({ type: "table" });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { pageSize, componentValuesArr, rowCount, modalIsOpen, editMode } =
      this.state;
    const { formApi, section } = this.props;

    if (
      !!formApi &&
      !!section?.modalFields &&
      !prevState.modalIsOpen &&
      !!modalIsOpen &&
      !!editMode
    ) {
      const { modalFields } = section;
      const modalValues = formApi.getState().values.add_values_field?.[0];
      if (!!modalValues) {
        // Set timeout necessary to have the function run after current call stack finishes
        // thus ensuring fields are registered
        setTimeout(() => {
          formApi.batch(() => {
            modalFields.forEach(({ machine_name }) => {
              const field = `add_values_field[0].${machine_name}`;
              const value = modalValues[machine_name];
              if (!!machine_name) {
                formApi.change(field, value);
                formApi.blur(field);
              }
            });
          });
        }, 0);
      }
    }
    if (componentValuesArr) {
      // Only run pageSize updates when number of items or page size changes
      if (
        pageSize !== prevState?.pageSize ||
        rowCount !== prevState?.rowCount
      ) {
        // Using rowCount for pagination because componentValuesArr is not reliable for rerendering when dynamically deleted through linkages
        this.setState({
          pageCount: Math.ceil(rowCount / pageSize),
        });
        // this.state.row isn't updated when rows are added through profiles. row state is required to correctly track linkage id generation
        this.updateFormValuesAndLocalStateValues();
      }
    }
  }

  renderField = (field, index, machine_name, show_error = true, name) => {
    const {
      inputResolver,
      appId,
      profiles,
      counties,
      formApi,
      formValues,
      page_index,
      disableValidation,
      form_ui,
      uiSchema,
    } = this.props;
    let fieldName = name + machine_name;
    // components with the same key weren't updating because keys were not unique
    let key = "";
    key += field && field.code ? field.code : "";
    key += uiSchema && uiSchema.prefix ? uiSchema.prefix : "";
    key += index ? index : "";
    key += machine_name ? machine_name : "";
    key += page_index ? page_index : "";
    key += page_index ? page_index : "";

    let input_resolver = inputResolver || FieldResolver;
    let component = input_resolver(field.widget) || "input";
    let schemaProps = { ...field };
    let showRequired = field.validate && field.validate[0] === "required";
    let disabled = { background: "#D3D3D3" };
    let isDisabled = false;
    if (field.disabled && field.disableWhenField !== undefined) {
      if (typeof field.disableWhenField === "string") {
        isDisabled = FieldDisabled(
          field.disabled,
          field.disableWhenField,
          formApi
        );
      } else {
        isDisabled = FieldDisabled(
          field.disabled,
          field.disableWhenField.when,
          formApi,
          undefined,
          field.disableWhenField.is
        );
      }
    } else {
      isDisabled = field.disabled;
    }
    // const normalizePhone = (value) => {
    //   if (!value) return value;
    //   const onlyNums = value.replace(/[^\d]/g, "");
    //   if (onlyNums.length <= 3) return onlyNums;
    //   if (onlyNums.length <= 7) return `(${onlyNums.slice(0, 3)}) ${onlyNums.slice(3, 7)}`;
    //   return `(${onlyNums.slice(0, 3)}) ${onlyNums.slice(3, 6)}-${onlyNums.slice(6, 10)}`;
    // };
    return (
      <Fragment key={key}>
        <div className={`usa-form-group`} style={field.style} key={key}>
          {field.label && (
            <Label
              hidden={field.hidden || field.labelHidden}
              htmlFor={machine_name}
            >
              {field.code && <span>{`${field.code}. `}</span>}
              <span
                dangerouslySetInnerHTML={{
                  __html: field.label,
                }}
              />
              <RequiredAsterisk
                show={showRequired || schemaProps.required === true}
              />
              {field.tooltip && <Tooltip content={field.tooltip} />}
              {field.clearBtn && (
                <ClearBtn
                  clearBtn={field.clearBtn}
                  machine_name={machine_name}
                  formApi={formApi}
                />
              )}
            </Label>
          )}
          <Field
            key={key}
            id={machine_name}
            name={fieldName}
            validate={
              disableValidation
                ? undefined
                : (values, allValues) =>
                    field.validate
                      ? validator(
                          field.validate,
                          allValues,
                          null,
                          counties
                        )(values)
                      : undefined
            }
            formApi={formApi}
            formValues={formValues}
            // parse={field.parse ? fieldParser(field.parse, schemaProps, formApi) : undefined}
            // format={field.format ? fieldFormatter(field.format, schemaProps, formApi) : undefined}
            component={component}
            type={field.widget}
            disabled={isDisabled}
            style={field.disabled ? disabled : undefined}
            schemaProps={schemaProps}
            editMode={this.state.editMode}
            value={
              field.value !== undefined
                ? field.value
                : field.choice !== undefined
                ? field.choice
                : undefined
            } // if field has both value and choice, prefer value
            maxLength={field.maxLength}
            showRequired={showRequired}
            appId={appId}
            hidden={field.hidden}
            profiles={profiles}
            counties={counties}
            inputType={field.inputType}
            form_ui={form_ui}
          />
        </div>
      </Fragment>
    );
  };
  fieldWarning = (field, formApi) => {
    if (field.warnings) {
      return field.warnings.map((warning) => (
        <Condition
          when={warning.isVisible.when}
          is={warning.isVisible.is}
          operator={warning.isVisible.operator}
          formApi={formApi}
          isInlineModal={true}
        >
          <div style={warningStyles}>{parse(warning.text)}</div>
        </Condition>
      ));
    } else if (field.warning) {
      return field.warning.isVisible ? (
        <Condition
          when={field.warning.isVisible.when}
          is={field.warning.isVisible.is}
          operator={field.warning.isVisible.operator}
          array={field.warning.isVisible.array}
          property={field.warning.isVisible.property}
          formApi={formApi}
          isInlineModal={true}
        >
          <div style={warningStyles}>{parse(field.warning.text)}</div>
        </Condition>
      ) : null;
    }
  };
  renderFieldGroup = (
    group,
    index,
    formApi,
    showIndividualFieldError,
    name
  ) => {
    return (
      // condition around the form group
      <Condition
        when={(group.isVisible && group.isVisible.when) || undefined}
        is={(group.isVisible && group.isVisible.is) || undefined}
        operator={(group.isVisible && group.isVisible.operator) || undefined}
        key={index}
        formApi={formApi}
        isInlineModal={true}
      >
        <div
          className={`usa-form-group`}
          style={
            group.hidden
              ? { display: "none" }
              : group.isVisible
              ? conditionalStyles
              : undefined
          }
        >
          <Label htmlFor={group.machine_name}>
            {group.code && <span>{`${group.code}. `}</span>}
            <span
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(group.label),
              }}
            />
            {group.required && group.required !== undefined && (
              <RequiredAsterisk show={true} />
            )}
            {group.tooltip && <Tooltip content={group.tooltip} />}
            {group.clearBtn && (
              <ClearBtn
                clearBtn={group.clearBtn}
                machine_name={group.machine_name}
                formApi={formApi}
                isInlineModal={true}
              />
            )}
          </Label>

          <div
            className={`${
              group &&
              group.fields &&
              group.fields[0] &&
              group.fields[0].widget === "anticipated_date"
                ? `anticipated_date ${group.className || ""}`
                : `${group.className || ""}`
            }`}
            style={group.columns ? checkboxStyleObj : undefined}
          >
            {group.fields.map((f, index) => {
              if (f.isGroup) {
                return this.renderFieldGroup(
                  f.isGroup,
                  null,
                  formApi,
                  true,
                  name
                ); // recursive call
              } else {
                return (
                  // condition around individual fields within the form group
                  <Condition
                    when={(f.isVisible && f.isVisible.when) || undefined}
                    is={(f.isVisible && f.isVisible.is) || undefined}
                    operator={
                      (f.isVisible && f.isVisible.operator) || undefined
                    }
                    formApi={formApi}
                    isInlineModal={true}
                  >
                    {f.widget !== "anticipated_date" ? (
                      <Fragment>
                        {this.renderField(
                          f,
                          index,
                          f.machine_name || group.machine_name,
                          (group.showIndividualFieldError !== undefined &&
                            group.showIndividualFieldError) ||
                            false, // if prop is present, otherwise assume error at group level
                          name
                        )}
                        {f.machine_name === "c12_emp_fein" ? (
                          <FEINValidation
                            formApi={formApi}
                            machine_name={f.machine_name}
                          />
                        ) : (
                          this.fieldWarning(f, formApi)
                        )}
                      </Fragment>
                    ) : f.machine_name.indexOf("total") < 0 ? (
                      this.renderField(
                        f,
                        index,
                        f.machine_name || group.machine_name,
                        (group.showIndividualFieldError !== undefined &&
                          group.showIndividualFieldError) ||
                          false, // if prop is present, otherwise assume error at group level
                        name
                      )
                    ) : null}
                  </Condition>
                );
              }
            })}
          </div>
          <FieldError
            field_name={`add_values_field[0].${group.machine_name}`}
            currentErrors={this.state.currentErrors}
          />
          <div>{this.fieldWarning(group, formApi)}</div>
        </div>
      </Condition>
    );
  };

  updateFormValuesAndLocalStateValues = () => {
    const { section, formApi } = this.props;
    const { master_fieldArray, machine_name } = section;

    const form_values = formApi.getState().values[machine_name];
    const master_fieldArray_value =
      formApi.getState().values[master_fieldArray];

    // If component is inLine(i.e Page 2), then push inLine values into separate array
    if (
      section.hasOwnProperty("master_fieldArray") &&
      master_fieldArray_value !== undefined &&
      !!master_fieldArray_value?.length
    ) {
      let componentArr_local = []; // Array for the specific Component.
      let remainingValuesArr_local = []; // Only if there is a master Array.

      // If Master_array_field exist, Push Master_array_field Values into one Arr and the remaining values into another arr
      for (let i = 0; i < master_fieldArray_value?.length; i++) {
        if (
          master_fieldArray_value[i].section_number ===
          section.modalFields[0].initialValue
        ) {
          componentArr_local.push(master_fieldArray_value[i]);
        } else {
          remainingValuesArr_local.push(master_fieldArray_value[i]);
        }
      }
      this.setState({
        componentValuesArr: componentArr_local,
        remainingValuesArr: remainingValuesArr_local,
        masterArr: master_fieldArray,
      });
    }
    // If master_array_field does not exist, then set local state to form_values
    else if (
      !section.hasOwnProperty("master_fieldArray") &&
      form_values !== undefined
    ) {
      this.setState({
        componentValuesArr: form_values,
      });
    }
  }; // End of updateFormAndStateValues()

  // Open Modal and push in a new Array of undefined FieldArray(undefined bc recommended in docs)
  openModal = (length) => {
    const { formApi } = this.props;
    if (formApi.getState().values.add_values_field === undefined) {
      formApi.mutators.push("add_values_field", undefined);
    }

    this.updateFormValuesAndLocalStateValues();

    this.setState({
      row: length,
      modalIsOpen: true,
    });
  }; // end of openModal()

  // Save New Values or edit existing Values via Modal
  handleModalSave = () => {
    const { section, formApi } = this.props;
    const { master_fieldArray, machine_name, sortBy } = section;
    const modal_values = formApi.getState().values.add_values_field[0];

    if (modal_values.hasOwnProperty("error")) {
      delete modal_values.error;
    }
    if (modal_values.hasOwnProperty("rowNum")) {
      delete modal_values?.rowNum;
    }
    // Check if required values exist before saving:
    if (
      modal_values == undefined ||
      modal_values.section_number === undefined ||
      modal_values.section_number.trim() === "" ||
      modal_values.section_details === undefined ||
      modal_values.section_details.trim() === ""
    ) {
      this.closeModal();
    }

    // Make Local Copy of state
    let componentArr_local = this.state.componentValuesArr
      ? [...this.state.componentValuesArr]
      : [];

    // If master_array_field exists:
    if (section.hasOwnProperty("master_fieldArray")) {
      const maintainSorting =
        section?.keepSortOnModalEdit && this.state.editMode === true;
      if (maintainSorting) {
        // Added to keep sorting on edit
        componentArr_local.splice(this.state.currentIndex, 1, modal_values);
      } else {
        if (!section?.keepSortOnModalEdit && this.state.editMode === true) {
          componentArr_local.splice(this.state.currentIndex, 1);
        }
        // Update the component Arr
        componentArr_local.push(modal_values);
      }

      const remainingValuesArr_local = [...this.state.remainingValuesArr];
      // Update the Master Arr:
      const masterArr_local = [
        ...componentArr_local,
        ...remainingValuesArr_local,
      ];

      // Update the FormState
      const path = window.location.pathname.split("/");
      let formId = path[3];
      let files = [];
      if (formId == "9035") {
        if (masterArr_local) {
          for (let i = 0; i < masterArr_local.length; i++) {
            masterArr_local[i].number_exempt_workers = parseInt(
              masterArr_local[i].number_exempt_workers
            );
            if (
              masterArr_local[i].transcript &&
              typeof masterArr_local[i].transcript === "object"
            ) {
              files = files.concat(masterArr_local[i].transcript);
            }
            if (
              masterArr_local[i].degree_diploma &&
              typeof masterArr_local[i].degree_diploma === "object"
            ) {
              files = files.concat(masterArr_local[i].degree_diploma);
            }
            if (
              masterArr_local[i].other_official_documents &&
              typeof masterArr_local[i].other_official_documents === "object"
            ) {
              files = files.concat(masterArr_local[i].other_official_documents);
            }
          }
        }
        formApi.change("files", files);
      }
      formApi.change(master_fieldArray, masterArr_local);

      const {
        linkageEditMode,
        linkageEditingObject: {
          idValue,
          toFieldArray,
          toLinkageIdFieldName,
          fieldsToModify,
        },
      } = this.state;

      if (linkageEditMode) {
        if (idValue) {
          const fieldArrayToModify =
            formApi?.getState()?.values?.[toFieldArray];
          fieldArrayToModify?.forEach((row) => {
            if (row?.[toLinkageIdFieldName] === idValue) {
              fieldsToModify?.forEach(({ set, from }) => {
                row[set] = modal_values?.[from];
              });
            }
            return row;
          });
        }
      }
      // Update the localState
      this.setState({
        componentValuesArr: componentArr_local,
        masterValuesArr: masterArr_local,
      });
    }
    // if editing values from Section array (i.e Addendum C Page), delete from Array and update values
    else if (!section.hasOwnProperty("master_fieldArray")) {
      const maintainSorting =
        section?.keepSortOnModalEdit && this.state.editMode === true;
      if (maintainSorting) {
        // Added to keep sorting on edit
        componentArr_local.splice(this.state.currentIndex, 1, modal_values);
      } else {
        if (!section?.keepSortOnModalEdit && this.state.editMode === true) {
          componentArr_local.splice(this.state.currentIndex, 1);
        }
        // Update the component Arr
        componentArr_local.push(modal_values);
      }

      // If sortBy is specified, run a sort function
      if (sortBy) {
        const { field, type } = sortBy;
        sortListBy({
          data: componentArr_local,
          field,
          type,
        });
      }

      // Update the FormState:
      const path = window.location.pathname.split("/");
      let formId = path[3];
      let files = [];
      if (formId == "9035") {
        if (componentArr_local) {
          for (let i = 0; i < componentArr_local.length; i++) {
            componentArr_local[i].number_exempt_workers = parseInt(
              componentArr_local[i].number_exempt_workers
            );
            if (
              componentArr_local[i].transcript &&
              typeof componentArr_local[i].transcript === "object"
            ) {
              files = files.concat(componentArr_local[i].transcript);
            }
            if (
              componentArr_local[i].degree_diploma &&
              typeof componentArr_local[i].degree_diploma === "object"
            ) {
              files = files.concat(componentArr_local[i].degree_diploma);
            }
            if (
              componentArr_local[i].other_official_documents &&
              typeof componentArr_local[i].other_official_documents === "object"
            ) {
              files = files.concat(
                componentArr_local[i].other_official_documents
              );
            }
          }
        }
        formApi.change("files", files);
      }

      formApi.change(machine_name, componentArr_local);

      // Update the local State
      this.setState({
        componentValuesArr: componentArr_local,
      });
    }
    this.closeModal();
  }; // End of HandleSave()

  // Reset Modal Values to undefined and close Modal
  closeModal = () => {
    const { formApi } = this.props;

    // Reset Modal values to undefined:
    formApi.change("add_values_field", undefined);

    this.setState({
      modalIsOpen: false,
      currentIndex: null,
      editMode: false,
    });
  }; // end of closeModal()

  onDeleteLinkage = (index, closePopupMenu) => {
    const { section, formApi } = this.props;
    let linkagesSchemaProps = section?.modalFields?.find((field) =>
      field.hasOwnProperty("linkages")
    );

    const {
      machine_name,
      linkages: {
        toFieldArray,
        fromFieldArray,
        toLinkageIdFieldName,
        removeRow,
      },
    } = linkagesSchemaProps;

    if (linkagesSchemaProps && toFieldArray) {
      let dataToModify = JSON.parse(
        JSON.stringify(formApi?.getState()?.values?.[toFieldArray] || [])
      );
      const idToDelete =
        formApi?.getState()?.values?.[fromFieldArray]?.[index]?.[machine_name];

      let rowDeletionData = [];
      let modifiedData = [];

      if (removeRow) {
        // Filter whole row
        dataToModify?.forEach((row) => {
          let filteredRow = row[toLinkageIdFieldName] !== idToDelete;
          if (filteredRow) {
            modifiedData = [...modifiedData, row];
          } else {
            rowDeletionData = [...rowDeletionData, row];
          }
        });
      } else {
        dataToModify?.forEach((row) => {
          let modifiedFieldArray = [];
          row?.[toLinkageIdFieldName]?.forEach((id) => {
            let filteredRow = id !== idToDelete;
            if (filteredRow) {
              modifiedFieldArray = [...modifiedFieldArray, id];
            } else {
              rowDeletionData = [...rowDeletionData, row];
            }
          });
          modifiedData = [
            ...modifiedData,
            { ...row, [toLinkageIdFieldName]: modifiedFieldArray },
          ];
        });
      }

      // If there are linked rows to delete, open modal and set up for linkage deletion
      if (rowDeletionData?.length > 0) {
        this.setState({
          linkageDeletionModalIsOpen: true,
          linkageDeletionObject: {
            linkageRowDeletionData: rowDeletionData,
            linkageModifiedData: modifiedData,
            linkageDeletionId: idToDelete,
            linkagesSchemaProps,
          },
        });
      } else {
        // otherwise, just directly delete row
        this.deleteitemByIndex(index, closePopupMenu);
      }
    }
  };

  // Deletes using index and updates local state
  deleteitemByIndex = (index, closePopupMenu) => {
    const { section, formApi } = this.props;
    const { master_fieldArray, machine_name } = section;

    let componentArr_local = [...this.state.componentValuesArr];

    if (section?.isLinkage) {
      const {
        linkageDeletionObject: {
          linkageModifiedData,
          linkagesSchemaProps: {
            linkages: { toFieldArray },
          },
        },
      } = this.state;
      if (toFieldArray && Array.isArray(linkageModifiedData)) {
        formApi.change(toFieldArray, linkageModifiedData);
      }

      // Reset to defaults for linkages
      this.setState({
        linkageDeletionObject: {
          linkageRowDeletionData: undefined,
          linkageModifiedData: undefined,
          linkageDeletionId: "",
          removeRow: false,
          linkagesSchemaProps: {
            linkages: {},
          },
        },
      });
    }

    // Delete from Inline Array (i.e. Page 2)
    if (section.hasOwnProperty("master_fieldArray")) {
      // Copied over from "updateFormValuesAndLocalStateValues" function
      // Need to re-update local and remaining values, if multiple inline on same page
      const master_fieldArray_value =
        formApi.getState().values[master_fieldArray];

      let componentArr_local = []; // Array for the specific Component.
      let remainingValuesArr_local = []; // Only if there is a master Array.

      for (let i = 0; i < master_fieldArray_value?.length; i++) {
        if (
          master_fieldArray_value[i].section_number ===
          section.modalFields[0].initialValue
        ) {
          componentArr_local.push(master_fieldArray_value[i]);
        } else {
          remainingValuesArr_local.push(master_fieldArray_value[i]);
        }
      }

      componentArr_local.splice(index, 1);

      // Update Master Array:
      const masterArr_local = [
        ...componentArr_local,
        ...remainingValuesArr_local,
      ];

      // Update FormState:
      formApi.change(master_fieldArray, masterArr_local);

      // Update localState:
      this.setState({
        masterValuesArr: masterArr_local,
        componentValuesArr: componentArr_local,
      });
    }
    // Delete from Field Array
    else if (section.hasOwnProperty("removeFromFieldArray")) {
      formApi.mutators.remove(section.machine_name, index);
    }
    // Delete from Section Array (i.e. Addendum C Page)
    else if (!section.hasOwnProperty("master_fieldArray")) {
      // Delete from local Array:
      componentArr_local.splice(index, 1);
      const path = window.location.pathname.split("/");
      let formId = path[3];
      if (formId == "9035") {
        let files = formApi.getState().values.files;
        if (files) {
          files = files.filter(
            (file) =>
              file.machine_name !== "transcript" + (index === 0 ? "" : index)
          );
          files = files.filter(
            (file) =>
              file.machine_name !==
              "degree_diploma" + (index === 0 ? "" : index)
          );
          files = files.filter(
            (file) =>
              file.machine_name !==
              "other_official_documents" + (index === 0 ? "" : index)
          );
        }
        // Update FormState;
        formApi.change("files", files);
      }
      formApi.change(machine_name, componentArr_local);
      formApi.mutators.remove(section.machine_name, index);
      // Update Local State:
      this.setState({
        componentValuesArr: componentArr_local,
      });
    }
    closePopupMenu && closePopupMenu();
  }; // end of deleteitemByIndex()

  // Takes index of item, and inserts it into Modal before opening Modal
  onEditInsertSelectedValueIntoModal = (index) => {
    const { formApi, section } = this.props;
    let new_modal_value;
    if (this.state.type === "table") {
      new_modal_value = formApi.getState().values[section.machine_name];
    } else {
      new_modal_value = this.state.componentValuesArr;
    }
    this.setState({ editMode: true, currentIndex: index });

    const editingField = {
      ...new_modal_value?.[index],
      // Add indexing for uniqueValueCheck validations
      rowNum: index,
    };

    const linkagesSchemaProps = section?.modalFields?.find((field) =>
      field?.hasOwnProperty("linkages")
    );

    if (linkagesSchemaProps) {
      const { linkages } = linkagesSchemaProps;
      const idValue = editingField?.[linkages?.toLinkageIdFieldName];
      this.setState({
        linkageEditingObject: {
          ...linkages,
          idValue,
        },
        linkageEditMode: true,
      });
    }

    formApi.mutators.update("add_values_field", 0, editingField);
    this.openModal(index);
  }; // end of onEditInsertSelectedValueIntoModal()

  // Loop over fields and create individual fields from UI Schema:
  renderFields = (section, name, index, values, modalMachineName) => {
    let fields = [];
    const { modalFields, machine_name } = section;
    const { formApi, counties } = this.props;

    for (let i = 0; i < modalFields.length; i++) {
      let fieldName = name + "." + modalFields[i].machine_name;

      const key = machine_name + fieldName;
      const showRequired =
        modalFields[i].validate && modalFields[i].validate[0] === "required";
      if (modalFields[i].isGroup) {
        fields.push(
          this.renderFieldGroup(
            modalFields[i].isGroup,
            null,
            formApi,
            true,
            name
          )
        );
      } else {
        let when = modalFields[i].isVisible && modalFields[i].isVisible.when;
        let prefix =
          modalFields[i].isVisible && modalFields[i].isVisible.prefix;
        let is = modalFields[i].isVisible && modalFields[i].isVisible.is;
        when = prefix ? `${prefix}[0][${when}]` : when;

        // For Initial Values
        const prefillValue =
          formApi?.getState()?.values?.[modalFields?.[i]?.prefillFromField];
        const initialValue = modalFields[i]?.["initialValue"] || prefillValue;

        fields.push(
          <Condition
            when={when || undefined}
            is={is || undefined}
            operator={
              (modalFields[i].isVisible && modalFields[i].isVisible.operator) ||
              undefined
            }
            key={index}
            formApi={formApi}
            isInlineModal={true}
          >
            <div className={"usa-form-group"}>
              {modalFields[i].label && (
                <Label hidden={modalFields[i].hidden} htmlFor={fieldName}>
                  {modalFields[i].code && (
                    <span>{`${modalFields[i].code} `}</span>
                  )}
                  <span
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(modalFields[i].label),
                    }}
                  />
                  <RequiredAsterisk show={showRequired} />
                  {modalFields[i].tooltip && (
                    <Tooltip content={modalFields[i].tooltip} />
                  )}
                  {modalFields[i].clearBtn && (
                    <ClearBtn
                      clearBtn={modalFields[i].clearBtn}
                      machine_name={machine_name}
                      formApi={formApi}
                    />
                  )}
                </Label>
              )}
              <Field
                maxLength={modalFields[i].maxLength || undefined}
                formApi={this.props.formApi}
                formValues={this.props.formValues}
                initialValue={
                  (!this.state.editMode && initialValue) || undefined
                }
                key={key}
                row={this.state.row}
                counties={counties}
                name={fieldName}
                tableName={name}
                component={FieldResolver(modalFields[i].widget)}
                type={modalFields[i].widget}
                // disabled={modalFields[i].disabled || false}
                disabled={
                  modalFields[i].disabled &&
                  modalFields[i].disableWhenField !== undefined
                    ? FieldDisabled(
                        modalFields[i].disabled,
                        modalFields[i].disableWhenField,
                        formApi,
                        modalMachineName
                      )
                    : modalFields[i].disabled
                }
                style={undefined}
                schemaProps={modalFields[i]}
                // value={modalFields[i].choice || undefined}
                parse={
                  modalFields[i].parse
                    ? fieldParser(modalFields[i].parse)
                    : undefined
                }
                showRequired={
                  modalFields[i].validate &&
                  modalFields[i].validate[0] === "required"
                }
                validate={(values, allValues) =>
                  modalFields[i].validate
                    ? validator(
                        modalFields[i].validate,
                        allValues,
                        i,
                        counties
                      )(values)
                    : undefined
                }
                hidden={modalFields[i].hidden}
              />
              {<FieldError key={fieldName} field_name={fieldName} />}
              {this.fieldWarning(modalFields[i], formApi)}
            </div>
          </Condition>
        );
      }
    }
    return fields;
  }; // end of renderFields()

  // Render Fields within on Field Array;
  renderFieldArray = () => {
    const { section } = this.props;
    const modalMachineName = "add_values_field";
    let sectionArr = [];
    sectionArr.push(
      <div>
        <FieldArray validate={null} name={modalMachineName} section={section}>
          {({ fields, meta: { error, invalid } }) =>
            fields.map((name, index, values) => (
              <div key={index}>
                {this.renderFields(
                  section,
                  name,
                  index,
                  values,
                  modalMachineName
                )}
              </div>
            ))
          }
        </FieldArray>
      </div>
    );
    return sectionArr;
  }; // end of renderFieldArray()

  render() {
    const { section, formApi, formValues, uiSchema } = this.props;
    const {
      sectionHeader,
      openModalHeader,
      modalHeader,
      machine_name,
      removeLink,
      modalFields,
      hide,
      maxAllowed,
      fullscreenModal,
    } = section;
    const { closeButton, closeButtonIcon } = styles;
    // Filter ModalFields to display on table based on hideOnTable prop in Schema
    const filteredModalFields = modalFields.filter(
      (i) => i.hideOnTable !== true
    );
    const modal_values = formApi.getState().values.add_values_field;

    const showEditBtn = section.editButton ? true : false;
    const path = window.location.pathname.split("/");
    let formId = path[3];
    let hideAdd =
      this.state.componentValuesArr &&
      section &&
      section.maxLength &&
      section.maxLength <= this.state.componentValuesArr.length
        ? true
        : false;

    // Hide if count is greater than or equal to maxAllowed
    hideAdd = this.state.componentValuesArr?.length >= maxAllowed;

    if (hide) if (hide(formApi) === true) hideAdd = true;

    if (!!this.props.disabledViaReuse) {
      hideAdd = this.props.disabledViaReuse;
    }

    const { pageSize, pageIndex, pageCount } = this.state;
    const setPageIndex = (index) => {
      if (index >= 0) {
        this.setState({ pageIndex: index });
      }
    };

    return (
      <div>
        <div className="inline-content">
          {formId === "790A" ? (
            <br></br>
          ) : (
            <h4>
              {formApi.getState().values[machine_name]
                ? formApi.getState().values[machine_name].length + " "
                : ""}
              {sectionHeader}
            </h4>
          )}

          {
            // Render Inline Add/Delete Section withing the specific Page
            this.state.componentValuesArr !== undefined &&
              section.listType === "inline" &&
              this.state.componentValuesArr.map((item, index) => {
                return (
                  <div className="inline-content-list" key={index}>
                    <div className="inline-content-header">
                      <span>
                        <i>
                          {
                            // Only Display Summary when it's present otherwise display only details
                            item.section_name
                              ? item.section_name + "-" + item.section_details
                              : item.section_details
                          }
                        </i>
                      </span>
                    </div>
                    <div
                      className="inline-content-edit"
                      onClick={() =>
                        this.onEditInsertSelectedValueIntoModal(index)
                      }
                    >
                      Edit
                    </div>
                    <div
                      className="inline-content-remove"
                      onClick={() => this.deleteitemByIndex(index)}
                    >
                      Remove
                    </div>
                  </div>
                );
              })
          }
          {
            // Render Addendum C Page here:
            this.state.componentValuesArr !== undefined &&
              // this.state.componentValuesArr !== [] &&
              section.listType === "table" && (
                <table id={machine_name} className="display-table">
                  <thead>
                    <tr>
                      {
                        // modalFields &&
                        // modalFields.machine_name &&

                        filteredModalFields.map((field) => (
                          <th>{field.tableHeader ?? field.label}</th>
                        ))
                      }
                      <th>Actions</th>
                    </tr>
                  </thead>

                  <FieldArray
                    name={machine_name}
                    section={section}
                    validate={(values, allValues) =>
                      section.validate
                        ? validator(section.validate, allValues, null)(values)
                        : undefined
                    }
                  >
                    {({ fields }) => {
                      let fieldValues = fields?.value;

                      // Update rowCount to force rerender linkage deletions
                      if (fieldValues?.length !== this.state.rowCount) {
                        this.setState({ rowCount: fieldValues?.length });
                      }

                      // Create paginated array of rows
                      if (section?.showPagination) {
                        const paginatedIndexStart = pageIndex * pageSize;
                        const paginatedIndexEnd =
                          paginatedIndexStart + pageSize;

                        fieldValues = fields?.value?.slice(
                          paginatedIndexStart,
                          paginatedIndexEnd
                        );
                      }

                      return fields && fieldValues
                        ? fieldValues?.map((item, index) => {
                            // Create paginated index
                            if (section?.showPagination) {
                              const paginatedIndex =
                                pageIndex * pageSize + index;

                              index = paginatedIndex;
                            }

                            return (
                              <tr>
                                {filteredModalFields.map((field) => {
                                  let hasError = item["error"] ? true : false;
                                  let value =
                                    typeof item[field.machine_name] ===
                                      "object" &&
                                    item[field.machine_name] &&
                                    item[field.machine_name].label != undefined
                                      ? item[field.machine_name].label
                                      : field.isGroup
                                      ? item[field.isGroup.machine_name]
                                      : item[field.machine_name];
                                  if (
                                    field.machine_name === "error" &&
                                    item[field.machine_name]
                                  ) {
                                    value = "Incomplete";
                                  }
                                  if (
                                    !!field.altFieldIfPresent &&
                                    !!formValues?.[machine_name]?.[index]?.[
                                      field.altFieldIfPresent
                                    ]
                                  ) {
                                    value =
                                      formValues[machine_name][index][
                                        field.altFieldIfPresent
                                      ];
                                  }
                                  const editableCell =
                                    field?.editLinkageTable && (
                                      <LinkageEditableCell
                                        value={value}
                                        field={field}
                                        formApi={formApi}
                                        index={index}
                                        setLinkageEditMode={(state) => {
                                          this.setState({
                                            linkageEditMode: state,
                                          });
                                        }}
                                        linkagesValues={
                                          this.state.linkagesValues
                                        }
                                        setLinkagesValues={(state) => {
                                          this.setState({
                                            linkagesValues: state,
                                          });
                                        }}
                                      />
                                    );

                                  return (
                                    <td
                                      className={hasError ? "has-error" : null}
                                    >
                                      {editableCell || value}
                                    </td>
                                  );
                                })}
                                <td className="actions-col">
                                  {showEditBtn ? (
                                    <button
                                      disabled={!!this.props.disabledViaReuse}
                                      type="button"
                                      className="btn usa-button usa-button--outline"
                                      onClick={() => {
                                        this.onEditInsertSelectedValueIntoModal(
                                          index
                                        );
                                      }}
                                    >
                                      Edit
                                    </button>
                                  ) : (
                                    <PopupMenu
                                      trigger={
                                        <button
                                          type="button"
                                          className="btn-app-docs modal-empty-button"
                                        >
                                          <b>. . .</b>
                                        </button>
                                      }
                                      position="bottom right"
                                      closeOnDocumentClick
                                      contentStyle={{
                                        padding: "8px",
                                        border: "1px",
                                        width: "140px",
                                      }}
                                    >
                                      {(closePopupMenu) => (
                                        <div className="menu">
                                          <div className="menu-item dropdown-label-View">
                                            <a
                                              rel="noopener noreferrer"
                                              target="_blank"
                                              href
                                              onClick={() => {
                                                this.onEditInsertSelectedValueIntoModal(
                                                  index
                                                );
                                                closePopupMenu();
                                              }}
                                            >
                                              Edit
                                            </a>
                                          </div>
                                          <div className="dropdown-seperator" />
                                          <div>
                                            <div
                                              className="menu-item dropdown-label-View"
                                              style={{ color: "#bf1111" }}
                                            >
                                              <span
                                                tabIndex="1"
                                                className={"index-" + index}
                                                onClick={() => {
                                                  if (section?.isLinkage) {
                                                    this.onDeleteLinkage(
                                                      index,
                                                      closePopupMenu
                                                    );
                                                  } else {
                                                    this.deleteitemByIndex(
                                                      index,
                                                      closePopupMenu
                                                    );
                                                  }
                                                }}
                                              >
                                                Remove
                                              </span>
                                            </div>
                                          </div>
                                          <DeleteLinkageModal
                                            isOpen={
                                              this.state
                                                .linkageDeletionModalIsOpen
                                            }
                                            setIsOpen={(state) =>
                                              this.setState({
                                                linkageDeletionModalIsOpen:
                                                  state,
                                              })
                                            }
                                            linkageDeletionObject={
                                              this.state.linkageDeletionObject
                                            }
                                            deleteItemByIndex={() =>
                                              this.deleteitemByIndex(index)
                                            }
                                            closePopupMenu={closePopupMenu}
                                          ></DeleteLinkageModal>
                                        </div>
                                      )}
                                    </PopupMenu>
                                  )}
                                </td>
                              </tr>
                            );
                          })
                        : null;
                    }}
                  </FieldArray>
                </table>
              )
          }
          {!hideAdd && (
            <div className="inline-content-header-section">
              <div
                disabled
                className="inline-content-add-header"
                onClick={() =>
                  this.openModal(
                    this.state.componentValuesArr
                      ? this.state.componentValuesArr.length
                      : 0
                  )
                }
                id={`${machine_name}`}
                // Allows keyboard navigation
                onKeyPress={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    this.openModal(
                      this.state.componentValuesArr
                        ? this.state.componentValuesArr.length
                        : 0
                    );
                  }
                }}
                tabIndex={0}
              >
                <strong disabled>+</strong> {openModalHeader}
              </div>
            </div>
          )}
          {section?.showPagination &&
            !!this.state.componentValuesArr?.length && (
              <PaginationComponent
                pageIndex={pageIndex}
                pageSizeOptions={[10, 25, 50, 100]}
                pageSize={pageSize}
                setPageSize={(size) => this.setState({ pageSize: size })}
                pageCount={pageCount}
                gotoPage={(index) => setPageIndex(index)}
                nextPage={() => setPageIndex(pageIndex + 1)}
                previousPage={() => setPageIndex(pageIndex - 1)}
                canNextPage={pageIndex + 1 < pageCount}
                canPreviousPage={pageIndex > 0}
              />
            )}
        </div>
        <div>
          <Modal
            isOpen={this.state.modalIsOpen}
            onRequestClose={() => this.closeModal()}
            overlayClassName="Overlay"
            className={`addendum-c-modal ${fullscreenModal && "fullscreen"}`}
          >
            <div className="modal-header">
              {modalHeader ? (
                <h1 className="modal-title">{modalHeader}</h1>
              ) : (
                ""
              )}
            </div>
            <div>
              <button
                style={closeButton}
                onClick={() => this.closeModal()}
                tabIndex={0}
                type="button"
              >
                <MdClose style={closeButtonIcon} />
              </button>
              <div className="modal-content">{this.renderFieldArray()}</div>
              <div className="footer-actions">
                {removeLink && this.state.editMode ? (
                  <button
                    type="button"
                    className="usa-button usa-button--unstyled remove-link"
                    onClick={() => {
                      this.deleteitemByIndex(this.state.currentIndex);
                      this.closeModal();
                    }}
                    href
                  >
                    {removeLink}
                  </button>
                ) : null}
                <div className="button-container">
                  <Button
                    coloring="cancel"
                    type="button"
                    onClick={() => this.closeModal()}
                  >
                    Cancel
                  </Button>
                  <Button
                    onClick={() => this.handleModalSave()}
                    coloring="blue"
                    type="button"
                    disabled={
                      modal_values && formApi.getState().errors.add_values_field
                    }
                  >
                    Save
                  </Button>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </div>
    );
  }
}
